import { render, staticRenderFns } from "./AddSPRPage.vue?vue&type=template&id=ed1ea2ce&scoped=true&"
import script from "./AddSPRPage.vue?vue&type=script&lang=js&"
export * from "./AddSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./AddSPRPage.vue?vue&type=style&index=0&id=ed1ea2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ea2ce",
  null
  
)

export default component.exports